import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  ResultContainer,
  ResultRow,
} from 'aem-libs-react-ts/src/components/calculators'
import { Tip } from 'aem-libs-react-ts/src/components/Tip'
import {
  GraphResultRow,
  TargetAmountResult,
} from 'aem-libs-regular-investment/src/components'

import { RF_RESULTS } from '../constants'
import { CalcType } from '../model/enums'
import {
  amountSelector,
  appSelector,
  savingsSelector,
} from '../store/selectors'

const ResultBoard = () => {
  const { t } = useTranslation()

  const { amountResult } = useSelector(amountSelector)
  const { savingsResult } = useSelector(savingsSelector)
  const { calcType } = useSelector(appSelector)

  const isAmountCalc = () => calcType === CalcType.Amount

  const result = isAmountCalc() ? amountResult : savingsResult

  return (
    <ResultContainer alignResults='center'>
      {isAmountCalc() && (
        <TargetAmountResult
          rf={RF_RESULTS.TARGET}
          amount={Math.round(amountResult.targetAmount)}
        >
          <Trans i18nKey={'RESULT.TARGET_LABEL'} t={t}>
            aaa<strong>bbb</strong>ccc
          </Trans>
        </TargetAmountResult>
      )}
      <GraphResultRow
        estimatedAmount={result.estimatedAmount}
        cumulativeAmount={result.cumulativeAmount}
      />
      <ResultRow label={t('RESULT.INTEREST_RATE')}>
        <strong className='csas-strong-small'>
          <span data-rf={RF_RESULTS.INTEREST_RATE}>
            {result.annualReturn &&
              result.annualReturn.toFixed(2).replace('.', ',')}
          </span>
          <span> % p. a. &nbsp;</span>
          <Tip position='left' tip={t('RESULT.INTEREST_RATE_TIP')} />
        </strong>
      </ResultRow>
      <ResultRow label={t('RESULT.PRODUCT_NAME')}>
        <strong className='csas-strong-small'>
          <span data-rf={RF_RESULTS.PRODUCT_NAME}>{result.productName}</span>
          &nbsp;
          <Tip position='left' tip={t('RESULT.' + result.productId + '.TIP')} />
        </strong>
      </ResultRow>
    </ResultContainer>
  )
}

export default ResultBoard
